// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import { QuoteBackedProposalBuilder } from './QuoteBackedProposalBuilder';

/**
 * Backward-compatible entry point for the PENSION sectioned builder (the
 * pension-only name predates the Investment & Protection Proposals
 * generalisation — docs/specs/investment-protection-proposals-prd.md RQ-8).
 * Pension keeps its exact route (`/relationships/:profileId/proposals/pension-builder[/:proposalId]`)
 * and behaviour; this is now a thin wrapper around the shared
 * {@link QuoteBackedProposalBuilder} so existing imports/tests keep working
 * unchanged. New call sites for Investment/Protection route directly to
 * `QuoteBackedProposalBuilder` from `App.tsx`.
 */
export function PensionProposalBuilder() {
  return <QuoteBackedProposalBuilder proposalType="PENSION" />;
}

export default PensionProposalBuilder;
